import React, { useState } from "react";
import arrowDown from "../assets/arrowDown.png";
import CheckBox from "../CheckBox/CheckBox";
import "./SinglefilterWrap.css";
import { useEffect } from "react";
import SingleSiderBarFilterTItleBox from "../SingleSiderBarFilterTItleBox/SingleSiderBarFilterTItleBox";

const SingleFilterWrap = ({ title, label, filterOption, setSideBarFilter }) => {
  const [open, setOpen] = useState(true);

  return (
    <div className="mt-[16px] ">
      <div
        onClick={() => setOpen((pre) => !pre)}
        className="flex cursor-pointer select-none items-center justify-between hover:opacity-80"
      >
        <h2 className="text-res-ls font-bold ">{title}</h2>
        <img
          className={`${!open ? "rotate-180" : "rotate-0"} transition-all`}
          src={arrowDown}
          alt="arrowDown"
        />
      </div>
      <div>
        <div className={`singleFilterWrap ${open && "open"} grid  `}>
          <div className="mt-[16px] flex min-h-0 flex-col gap-[8px] ">
            {filterOption.map((single, i) => (
              <SingleSiderBarFilterTItleBox
                key={i}
                setSideBarFilter={setSideBarFilter}
                {...single}
              ></SingleSiderBarFilterTItleBox>
            ))}
            <hr className="mt-[15px] h-[1px] border-[#3C3C56] bg-transparent" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleFilterWrap;
